export enum RefetchKey {
  All = 'all',
  CustomFields = 'custom-fields',
  ProjectData = 'project-data',
  Report = 'report',
  Rundown = 'rundown',
  UrlPresets = 'url-presets',
  ViewSettings = 'view-settings',
  Translation = 'translation',
  Settings = 'settings',
}
